import { render, staticRenderFns } from "./aliMap.vue?vue&type=template&id=faa639c6&scoped=true&"
import script from "./aliMap.vue?vue&type=script&lang=js&"
export * from "./aliMap.vue?vue&type=script&lang=js&"
import style0 from "./aliMap.vue?vue&type=style&index=0&id=faa639c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa639c6",
  null
  
)

export default component.exports